import {Injectable, signal, WritableSignal} from '@angular/core';
import {User, UserRole} from "../interfaces/api-interfaces";

@Injectable({
  providedIn: 'root'
})
export class KeycloakService {
  allowedRoles: string[] = ['admin', "developer", "user", "ai_office", "management"];
  currentUser: WritableSignal<User | null> = signal(null)

  isAdmin(user: User): boolean {
    return user.roles.includes(UserRole.MANAGEMENT) || user.roles.includes(UserRole.AI_OFFICE);
  }

}